import React, { useState, useEffect } from 'react';
import { styles, colors } from '../../styles/globalStyles';

const overlay = {
  position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.6)',
  display: 'flex', alignItems: 'flex-start', justifyContent: 'center',
  zIndex: 2000, padding: '0.5rem', overflowY: 'auto',
  WebkitOverflowScrolling: 'touch',
};

const box = {
  background: '#fff', borderRadius: '12px',
  padding: 'clamp(1rem, 4vw, 2rem)',
  width: '100%', maxWidth: '760px', margin: 'auto',
  boxShadow: '0 20px 60px rgba(0,0,0,0.35)',
  boxSizing: 'border-box',
};

const section = {
  borderTop: `2px solid ${colors.primary}`,
  paddingTop: '1rem', marginTop: '1.5rem',
};

const sectionTitle = {
  fontWeight: '700', fontSize: '0.95rem', color: colors.primary,
  textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '1rem',
};

const row = { display: 'grid', gap: '1rem', marginBottom: '0.75rem' };
const col2 = { ...row, gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))' };
const col3 = { ...row, gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))' };

const label = { fontSize: '0.8rem', fontWeight: '600', color: '#475569', marginBottom: '0.25rem', display: 'block' };
const input = { ...styles.formInput, fontSize: '16px' };
const textarea = { ...styles.formInput, fontSize: '16px', minHeight: '70px', resize: 'vertical' };

const OBJETIVOS_PILATES = [
  'Condicionamento físico', 'Fortalecimento muscular', 'Emagrecimento',
  'Melhora da postura', 'Reabilitação', 'Alívio de dores', 'Qualidade de vida',
];

const FREQUENCIAS = ['1x por semana', '2x por semana', '3x por semana'];

const PLANOS = ['Mensal', 'Trimestral', 'Semestral', 'Pacote de 5 aulas', 'Pacote de 10 aulas'];

const FORMAS_PAGAMENTO = ['PIX', 'Cartão de Crédito', 'Cartão de Débito', 'Dinheiro', 'Transferência Bancária'];

const OBJETIVOS_TRATAMENTO = [
  'Redução da dor', 'Melhora da postura', 'Ganho de força muscular',
  'Ganho de flexibilidade', 'Melhora da mobilidade', 'Prevenção de lesões',
  'Reabilitação pós-cirúrgica', 'Condicionamento físico', 'Equilíbrio', 'Qualidade de vida',
];

const CheckGroup = ({ options, value = [], onChange, outroLabel = 'Outro:', outroValue, onOutroChange }) => (
  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem 1.25rem' }}>
    {options.map(op => (
      <label key={op} style={{ display: 'flex', alignItems: 'center', gap: '0.375rem', fontSize: '0.875rem', cursor: 'pointer' }}>
        <input
          type="checkbox"
          checked={value.includes(op)}
          onChange={e => {
            if (e.target.checked) onChange([...value, op]);
            else onChange(value.filter(v => v !== op));
          }}
        />
        {op}
      </label>
    ))}
    <label style={{ display: 'flex', alignItems: 'center', gap: '0.375rem', fontSize: '0.875rem', cursor: 'pointer' }}>
      <input
        type="checkbox"
        checked={!!outroValue}
        onChange={e => { if (!e.target.checked) onOutroChange(''); }}
      />
      {outroLabel}
      <input
        type="text"
        value={outroValue || ''}
        onChange={e => onOutroChange(e.target.value)}
        style={{ ...input, width: '120px', maxWidth: '100%', flex: '1 1 80px', marginLeft: '0.25rem', padding: '0.25rem 0.5rem' }}
        placeholder="especificar"
      />
    </label>
  </div>
);

const RadioGroup = ({ options, value, onChange, outroLabel = 'Outro:', outroValue, onOutroChange }) => (
  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem 1.25rem' }}>
    {options.map(op => (
      <label key={op} style={{ display: 'flex', alignItems: 'center', gap: '0.375rem', fontSize: '0.875rem', cursor: 'pointer' }}>
        <input type="radio" checked={value === op} onChange={() => onChange(op)} />
        {op}
      </label>
    ))}
    <label style={{ display: 'flex', alignItems: 'center', gap: '0.375rem', fontSize: '0.875rem', cursor: 'pointer' }}>
      <input
        type="radio"
        checked={!!outroValue && !options.includes(value)}
        onChange={() => onChange('__outro__')}
      />
      {outroLabel}
      <input
        type="text"
        value={outroValue || ''}
        onChange={e => { onChange('__outro__'); onOutroChange(e.target.value); }}
        style={{ ...input, width: '120px', maxWidth: '100%', flex: '1 1 80px', marginLeft: '0.25rem', padding: '0.25rem 0.5rem' }}
        placeholder="especificar"
      />
    </label>
  </div>
);

const empty = {
  cpf: '', data_nascimento: '', endereco: '', profissao: '',
  contato_emergencia: '', telefone_emergencia: '',
  objetivo_pilates: [], objetivo_outro: '',
  data_inicio_plano: '', frequencia_semanal: '', frequencia_outro: '',
  plano_contratado: '', plano_outro: '', valor_plano: '', forma_pagamento: '',
  data_vencimento_plano: '', responsavel_pagamento: '',
  data_avaliacao: '', diagnostico_fisio: '', queixa_principal: '',
  objetivos_tratamento: [], objetivos_trat_outro: '',
  metas_estabelecidas: '', restricoes_cuidados: '', conduta_proposta: '',
};

export const FichaAluno = ({ aluno, createApi, onClose }) => {
  const [ficha, setFicha] = useState(empty);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [erro, setErro] = useState('');
  const [sucesso, setSucesso] = useState('');
  const [fichaVazia, setFichaVazia] = useState(false);

  const set = (field, value) => setFicha(f => ({ ...f, [field]: value }));

  useEffect(() => {
    const api = createApi();
    api.get(`/admin/usuarios/${aluno.id}/ficha`)
      .then(r => {
        const d = r.data.ficha || {};
        const isVazia = !d.id;
        setFichaVazia(isVazia);
        setFicha({
          cpf: d.cpf || '',
          data_nascimento: d.data_nascimento?.split('T')[0] || '',
          endereco: d.endereco || '',
          profissao: d.profissao || '',
          contato_emergencia: d.contato_emergencia || '',
          telefone_emergencia: d.telefone_emergencia || '',
          objetivo_pilates: d.objetivo_pilates || [],
          objetivo_outro: d.objetivo_outro || '',
          data_inicio_plano: d.data_inicio_plano?.split('T')[0] || '',
          frequencia_semanal: d.frequencia_semanal || '',
          frequencia_outro: d.frequencia_outro || '',
          plano_contratado: d.plano_contratado || '',
          plano_outro: d.plano_outro || '',
          valor_plano: d.valor_plano || '',
          forma_pagamento: d.forma_pagamento || '',
          data_vencimento_plano: d.data_vencimento_plano?.split('T')[0] || '',
          responsavel_pagamento: d.responsavel_pagamento || '',
          data_avaliacao: d.data_avaliacao?.split('T')[0] || '',
          diagnostico_fisio: d.diagnostico_fisio || '',
          queixa_principal: d.queixa_principal || '',
          objetivos_tratamento: d.objetivos_tratamento || [],
          objetivos_trat_outro: d.objetivos_trat_outro || '',
          metas_estabelecidas: d.metas_estabelecidas || '',
          restricoes_cuidados: d.restricoes_cuidados || '',
          conduta_proposta: d.conduta_proposta || '',
        });
      })
      .catch(e => {
        const status = e.response?.status;
        if (status === 404) {
          setFichaVazia(true);
        } else {
          setErro('Não foi possível carregar a ficha. Verifique sua conexão e tente novamente.');
        }
      })
      .finally(() => setLoading(false));
  }, [aluno.id]);

  const salvar = async () => {
    setSaving(true); setErro(''); setSucesso('');
    try {
      const api = createApi();
      await api.put(`/admin/usuarios/${aluno.id}/ficha`, ficha);
      setSucesso('Ficha salva com sucesso!');
      setTimeout(() => setSucesso(''), 3000);
    } catch (e) {
      setErro(e.response?.data?.error || 'Erro ao salvar ficha');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={overlay} onClick={e => { if (e.target === e.currentTarget) onClose(); }}>
      <div style={box}>
        {/* Cabeçalho */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
          <div>
            <h3 style={{ margin: 0, color: colors.dark }}>Ficha de Cadastro e Anamnese</h3>
            <p style={{ margin: '0.25rem 0 0', fontSize: '0.875rem', color: colors.gray }}>{aluno.nome} — {aluno.email}</p>
          </div>
          <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: '1.5rem', cursor: 'pointer', color: colors.gray }}>✕</button>
        </div>

        {erro && <div style={{ ...styles.alert, ...styles.alertError, marginBottom: '1rem' }}>{erro}</div>}
        {sucesso && <div style={{ ...styles.alert, ...styles.alertSuccess, marginBottom: '1rem' }}>{sucesso}</div>}
        {fichaVazia && !erro && (
          <div style={{ background: '#f0f9ff', border: '1px solid #bae6fd', borderRadius: '8px', padding: '10px 14px', marginBottom: '1rem', fontSize: '0.875rem', color: '#0369a1' }}>
            Ficha ainda não preenchida — preencha os dados abaixo e clique em <strong>Salvar Ficha</strong>.
          </div>
        )}

        {loading ? (
          <div style={{ textAlign: 'center', padding: '3rem' }}><div style={styles.spinner}></div></div>
        ) : (<>

          {/* ── DADOS PESSOAIS ── */}
          <div style={section}>
            <div style={sectionTitle}>Dados Pessoais</div>
            <div style={col2}>
              <div><span style={label}>CPF</span><input style={input} value={ficha.cpf} onChange={e => set('cpf', e.target.value)} placeholder="000.000.000-00" /></div>
              <div><span style={label}>Data de Nascimento</span><input type="date" style={input} value={ficha.data_nascimento} onChange={e => set('data_nascimento', e.target.value)} /></div>
            </div>
            <div style={col2}>
              <div><span style={label}>Profissão</span><input style={input} value={ficha.profissao} onChange={e => set('profissao', e.target.value)} placeholder="Profissão" /></div>
              <div><span style={label}>Endereço</span><input style={input} value={ficha.endereco} onChange={e => set('endereco', e.target.value)} placeholder="Rua, número, bairro" /></div>
            </div>
            <div style={col2}>
              <div><span style={label}>Contato de Emergência</span><input style={input} value={ficha.contato_emergencia} onChange={e => set('contato_emergencia', e.target.value)} placeholder="Nome do contato" /></div>
              <div><span style={label}>Telefone de Emergência</span><input type="tel" style={input} value={ficha.telefone_emergencia} onChange={e => set('telefone_emergencia', e.target.value)} placeholder="(11) 99999-9999" /></div>
            </div>
          </div>

          {/* ── ANAMNESE ── */}
          <div style={section}>
            <div style={sectionTitle}>Anamnese</div>
            <div style={{ marginBottom: '0.75rem' }}>
              <span style={label}>Objetivo com o Pilates</span>
              <CheckGroup
                options={OBJETIVOS_PILATES}
                value={ficha.objetivo_pilates}
                onChange={v => set('objetivo_pilates', v)}
                outroValue={ficha.objetivo_outro}
                onOutroChange={v => set('objetivo_outro', v)}
              />
            </div>
          </div>

          {/* ── DADOS DO PLANO ── */}
          <div style={section}>
            <div style={sectionTitle}>Dados do Plano de Pilates</div>
            <div style={col2}>
              <div><span style={label}>Data de Início do Plano</span><input type="date" style={input} value={ficha.data_inicio_plano} onChange={e => set('data_inicio_plano', e.target.value)} /></div>
              <div><span style={label}>Data de Vencimento</span><input type="date" style={input} value={ficha.data_vencimento_plano} onChange={e => set('data_vencimento_plano', e.target.value)} /></div>
            </div>
            <div style={{ marginBottom: '0.75rem' }}>
              <span style={label}>Frequência Semanal</span>
              <RadioGroup
                options={FREQUENCIAS}
                value={ficha.frequencia_semanal}
                onChange={v => set('frequencia_semanal', v)}
                outroValue={ficha.frequencia_outro}
                onOutroChange={v => set('frequencia_outro', v)}
              />
            </div>
            <div style={{ marginBottom: '0.75rem' }}>
              <span style={label}>Plano Contratado</span>
              <RadioGroup
                options={PLANOS}
                value={ficha.plano_contratado}
                onChange={v => set('plano_contratado', v)}
                outroValue={ficha.plano_outro}
                onOutroChange={v => set('plano_outro', v)}
              />
            </div>
            <div style={col2}>
              <div>
                <span style={label}>Valor do Plano</span>
                <input type="number" step="0.01" style={input} value={ficha.valor_plano} onChange={e => set('valor_plano', e.target.value)} placeholder="R$ 0,00" />
              </div>
              <div>
                <span style={label}>Responsável pelo Pagamento</span>
                <input style={input} value={ficha.responsavel_pagamento} onChange={e => set('responsavel_pagamento', e.target.value)} placeholder="Se diferente do aluno" />
              </div>
            </div>
            <div style={{ marginBottom: '0.75rem' }}>
              <span style={label}>Forma de Pagamento</span>
              <RadioGroup
                options={FORMAS_PAGAMENTO}
                value={ficha.forma_pagamento}
                onChange={v => set('forma_pagamento', v)}
                outroValue={null}
                onOutroChange={() => {}}
              />
            </div>
          </div>

          {/* ── PLANO DE TRATAMENTO ── */}
          <div style={section}>
            <div style={sectionTitle}>Plano de Tratamento</div>
            <div style={col2}>
              <div><span style={label}>Data da Avaliação Inicial</span><input type="date" style={input} value={ficha.data_avaliacao} onChange={e => set('data_avaliacao', e.target.value)} /></div>
              <div><span style={label}>Diagnóstico Fisioterapêutico</span><input style={input} value={ficha.diagnostico_fisio} onChange={e => set('diagnostico_fisio', e.target.value)} placeholder="Se aplicável" /></div>
            </div>
            <div style={{ marginBottom: '0.75rem' }}>
              <span style={label}>Queixa Principal</span>
              <textarea style={textarea} value={ficha.queixa_principal} onChange={e => set('queixa_principal', e.target.value)} placeholder="Descreva a queixa principal..." />
            </div>
            <div style={{ marginBottom: '0.75rem' }}>
              <span style={label}>Objetivos do Tratamento</span>
              <CheckGroup
                options={OBJETIVOS_TRATAMENTO}
                value={ficha.objetivos_tratamento}
                onChange={v => set('objetivos_tratamento', v)}
                outroValue={ficha.objetivos_trat_outro}
                onOutroChange={v => set('objetivos_trat_outro', v)}
              />
            </div>
            <div style={{ marginBottom: '0.75rem' }}>
              <span style={label}>Metas Estabelecidas</span>
              <textarea style={textarea} value={ficha.metas_estabelecidas} onChange={e => set('metas_estabelecidas', e.target.value)} placeholder="Metas de curto, médio e longo prazo..." />
            </div>
            <div style={{ marginBottom: '0.75rem' }}>
              <span style={label}>Restrições e Cuidados Especiais</span>
              <textarea style={textarea} value={ficha.restricoes_cuidados} onChange={e => set('restricoes_cuidados', e.target.value)} placeholder="Lesões, contraindicações, cuidados..." />
            </div>
            <div style={{ marginBottom: '0.75rem' }}>
              <span style={label}>Conduta Proposta</span>
              <textarea style={textarea} value={ficha.conduta_proposta} onChange={e => set('conduta_proposta', e.target.value)} placeholder="Protocolo, exercícios, progressão..." />
            </div>
          </div>

          {/* Ações */}
          <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'flex-end', marginTop: '1.5rem' }}>
            <button onClick={onClose} style={{ ...styles.button, ...styles.buttonOutline }}>Fechar</button>
            <button onClick={salvar} disabled={saving} style={{ ...styles.button, ...styles.buttonPrimary, opacity: saving ? 0.7 : 1 }}>
              {saving ? 'Salvando...' : 'Salvar Ficha'}
            </button>
          </div>
        </>)}
      </div>
    </div>
  );
};
